import React, {useState, type FC, useEffect} from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { BottomSheet } from "components/atoms/BottomSheet";
import { ReactComponent as AppleSVG } from "assets/images/apple.svg";
import { ReactComponent as ShareAppleSVG } from "assets/images/share-apple.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";
import ShareMenuImage from "assets/images/safariShareMenu.png";
import {isRunningStandalone, isIphone} from 'utils/device';
import localStorage from "redux-persist/es/storage";

export const InstallPromptMenu: FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    localStorage.getItem('install').then((isShowedInstall: string | null) => {
      setIsOpen(!isShowedInstall && !isRunningStandalone() && isIphone())
    })
  }, [])

  const onClose = () => {
    localStorage.setItem('install', 'showed')
    setIsOpen(false);
  }

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} Title={
      <Stack p="1rem" direction="row-reverse" alignItems="center" spacing=".5rem">
        <AppleSVG />
        <Typography fontSize={"1.1rem"} fontWeight={700}>
          نصب اپلیکیشن آواگپ برای آیفون
        </Typography>
      </Stack>
    }>
      <Stack alignItems="flex-end" p=".5rem" spacing={2}>
        <Stack direction="row-reverse" alignItems="center" justifyContent="center" textAlign="right" spacing=".2rem">
          <Typography fontSize="2rem" fontWeight={700} dir="rtl">
            ۱
          </Typography>
          <Typography fontSize=".8rem" fontWeight={700} dir="rtl">
            در منوی مرورگر (نوار پایین صفحه) گزینه‌ی
            <ShareAppleSVG />
            را انتخاب کنید.
          </Typography>
        </Stack>
        <Stack direction="row-reverse" alignItems="center" justifyContent="center" textAlign="right" spacing=".2rem" flexWrap="wrap">
          <Typography fontSize="2rem" fontWeight={700} dir="rtl">
            ۲
          </Typography>
          <Typography fontSize=".8rem" fontWeight={700} dir="rtl">
            به پایین رفته و گزینه‌ی Add to homescreen را لمس کنید.
          </Typography>
        </Stack>
        <Box width="60%" padding={0} alignSelf="center">
          <LazyLoadImage src={ShareMenuImage} width="100%" alt=""/>
        </Box>
        <Typography fontSize=".8rem" fontWeight={700} dir="rtl">
          اکنون آواگپ در کنار دیگر اپلیکیشن‌های شماست.
        </Typography>
        <Stack mx={5} my={5} alignSelf={"stretch"} spacing={1}>
          <Button variant={"contained"} fullWidth onClick={onClose}>
            متوجه شدم
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  );
};
